import React, { useEffect } from "react";
import { useSelector } from "react-redux";

const StatusBadge = ({
  contact,
  memoizedUserIdsArray,
  right = "4px",
  bottom = "-4px",
}) => {
  const onlineUsers = useSelector((state) => state.Buzzcom.onlineUsers);
  // Determine badge color based on the conditions
  const contacts = contact?.contacts?.length > 1 && contact?.contacts[1];
  const [isOnline, setIsOnline] = React.useState(false);
  const badgeColor =
    contact?.status !== "blocked" && isOnline
      ? "#18E448" // Green for active
      : "#ff6500"; // orange for others

  // Determine the avatar content
  const imageUrl = contact?.imageUrl || contacts?.imageUrl; // Replace `imageUrl` with the actual property name
  const userName = contact?.userName || contacts?.name || "U"; // Default to "U" if name is unavailable
  const avatarContent = imageUrl ? (
    <img
      className="rounded-circle"
      src={imageUrl}
      alt={userName}
      style={{ width: "40px", height: "40px", objectFit: "cover" }}
    />
  ) : (
    <div
      className="rounded-circle d-flex justify-content-center align-items-center bg-secondary text-white"
      style={{ width: "40px", height: "40px", fontSize: "15px" }}
    >
      {userName.charAt(0).toUpperCase()}
    </div>
  );

  console.log("contact is", contact);

  useEffect(() => {
    if (onlineUsers.length > 0) {
      const contactId = contact?.contacts?.[1]?.userId;
      const isOnline = onlineUsers.includes(contactId);
      if (isOnline) {
        setIsOnline(true);
      } else {
        setIsOnline(false);
      }
    }
  }, [onlineUsers]);

  return (
    <div className="position-relative d-inline-block">
      {/* Avatar */}
      {avatarContent}

      {/* Dot Badge */}
      <span
        className="position-absolute translate-middle rounded-circle"
        style={{
          width: "12px",
          height: "12px",
          backgroundColor: badgeColor,
          bottom: bottom, // Align at the bottom
          right: right, // Align at the right
          border: "0.7px solid white", // Optional: Create a border effect
        }}
      ></span>
    </div>
  );
};

export default StatusBadge;
